import React from 'react';

const SignUpForm = (props) => {

  return (
    <form className="row">

      <label className="col-4 pt-1 pr-0 pl-0">
        <span className={props.formErrors.name !== '' ? 'red-font' : ''}>
            Full Name:
        </span>
      </label>
      <input className="col-8 col-sm-7 mb-2" type="text" value={props.user.name} onChange={(e) => props.updateUser('name', e.target.value)}/>

      <label className="col-4 pt-1 pr-0 pl-0">
        <span className={props.formErrors.email !== '' ? 'red-font' : ''}>
            Email:
        </span>
      </label>
      <input className="col-8 col-sm-7 mb-2" type="text" value={props.user.email} onChange={(e) => props.updateUser('email', e.target.value)}/>

          <label className="col-4 pt-1 pr-0 pl-0">
            <span className={props.formErrors.postalCode !== '' ? 'red-font' : ''}>
                Postal Code:
            </span>
          </label>
      <input className="col-8 col-sm-7 mb-4" type="text" value={props.user.postalCode} onChange={(e) => props.updateUser('postalCode', e.target.value)}/>

      <div className="col-2 clear-both p-0 pr-2 text-right">
        <input type="checkbox" checked={props.user.subscribeToMainList} onChange={(e) => props.updateUser('subscribeToMainList', e.target.checked)} />
      </div>
      <div className="subscribe-message col-10 col-sm-9 p-0 mb-3">
        Subscribe to emails to stay up-to-date with the latest news, offers, articles and more from Heart to Home Meals (optional)
      </div>

      <div className="col-11 text-center">
              <button className="btn btnApetito pt-2" onClick={(e) => props.tryToSignUp(e)} disabled={!props.nameValid || !props.emailValid || !props.postalCodeValid}>
          Download Now
        </button>
      </div>
    </form>
  )
};

export default SignUpForm;
